import { Injectable, inject } from '@angular/core';
import { Observable, of, from } from 'rxjs';
import { MessageDTO, MessagesHistoryIdentifier, MessagesListDTO } from '../shared/models/messages.types';
import { ApiResponse } from '../interfaces/api';
import { SessionResponse } from '../interfaces/sessions';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment'
import { StateService } from './state.service';
import { switchMap } from 'rxjs/operators';
import { AuthTokenService } from './auth-token.service';


@Injectable({
  providedIn: 'root',
})
export class MessagesApiService {
  private readonly authTokenService = inject(AuthTokenService);

  constructor(
    private stateService: StateService,
    private httpClient: HttpClient,
  ) {}

  getMessagesById(identifier: MessagesHistoryIdentifier): Observable<MessagesListDTO> {
    return of ([]);
  }

  getSessionMessagesById(id: string): Observable<ApiResponse<SessionResponse>> {
      const params: Record<string, any> = {
        includeMessages: true,
      }

      return from(this.authTokenService.getAccessToken()).pipe(
        switchMap((token) => {
          const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-schema': this.stateService.schema,
          });
          return this.httpClient.get<ApiResponse<SessionResponse>>(`${environment.baseURL}/v1/session/${id}`, { params, headers });
        })
      );
    }

  sendMessage(message: any): Observable<MessageDTO> {
    return of ({ text: message.text });
  }
}
